export default __webpack_public_path__ + "static/media/org_entity.fa301c40.svg";